import React, {useState} from "react";
import '../styles/xmkbox.css';
import Boxes from "./xmkbox/Boxes";
import axios from "axios";
import {config} from "../config";
import Inbox from "./xmkbox/Inbox";
import Thread from "./xmkbox/Thread";
import envelopeIcon from "../assets/images/icons/envelope.svg";


export default function XMKbox({lang, user, screen, setPreloaderState}: any) {
    const [inbox, setInbox] = useState<any>(null);
    const [threads, setThreads] = useState([]);
    const [thread, setThread] = useState(null);

    const inboxName = (address: string) => {
        const parts = address.split('@');
        parts[1] = parts[1].split('.')[0];
        let name = parts[0].split('.');

        if (parts[1] === 'citizen') {
            return name[0][0] + '...' + name[name.length - 1];
        }

        return parts[0] + '@' + parts[1] + '...';
    }

    const threadName = (thread: any) => {
        if (thread === null) {
            return '';
        }

        const subject = thread[0].subject;

        if (subject.length > 20) {
            return subject.substring(0, 17) + '...';
        }

        return subject;
    }

    const openBox = (id: number) => {
        setPreloaderState(true);

        axios.get(config.api + '/xmkbox/' + id)
            .then(response => {
                setInbox(response.data.box);
                setThreads(response.data.threads);
                setPreloaderState(false);
            })
            .catch(() => {
                setPreloaderState(false);
            });
    }

    const clickOnAddress = () => {
        if (thread) {
            setThread(null);

            return;
        }

        setInbox(null);
    };

    // console.log(thread);

    return (
        <div id="xmkbox" style={{display: user === null || screen !== 'xmkbox' ? 'none' : 'block'}}>
            <div className="container">
                <div className="row">
                    <div className="col">
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb">
                                <li className="breadcrumb-item" aria-current="page" onClick={() => clickOnAddress()}>
                                    <img src={envelopeIcon} alt="xmkBOX" style={{height: '1em'}} />
                                </li>
                                {inbox === null ? '' : (<li className="breadcrumb-item" aria-current="page" onClick={() => setThread(null)}>{inboxName(inbox.address)}</li>)}
                                {inbox && thread ? (<li className="breadcrumb-item" aria-current="page">{threadName(thread)}</li>) : ''}
                            </ol>
                        </nav>

                        <hr />
                    </div>
                </div>
            </div>

            {!inbox && !thread ? <Boxes openBox={openBox} /> : ''}
            {inbox && !thread ? <Inbox lang={lang} inbox={inbox} threads={threads} setThread={setThread} setPreloaderState={setPreloaderState} /> : ''}
            {inbox && thread ? <Thread lang={lang} inbox={inbox} messages={thread} /> : ''}
        </div>
    );
}
